export default {
  'role-delegation': {
    'role-delegation': {
      actions: {
        add: false,
        edit: true,
        delete: false
      }
    }
  }
};
